<template>
    <v-container v-if="company.search.data">
        <v-row text-center wrap>
            <v-col xs="12" sm="12" md="12" lg="8" xl="8">
                <v-card>
                    <v-toolbar flat class="grey lighten-4">
                        <v-toolbar-title>Компания {{ company.search.data.name }}</v-toolbar-title>
                        <v-spacer/>
                        <v-btn
                            @click="updateCompanyPopup(company.search.data)"
                            color="primary"
                        >
                            Редактировать
                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <v-row wrap text-left subheading>
                            <v-col xs="6" sm="4" md="4" lg="3" xl="3">
                                ID:
                            </v-col>
                            <v-col xs="6" sm="8" md="8" lg="3" xl="3">
                                {{ company.search.data.id }}
                            </v-col>
                        </v-row>
                        <v-row wrap text-left subheading>
                            <v-col xs="6" sm="4" md="4" lg="3" xl="3">
                                Статус:
                            </v-col>
                            <v-col xs="6" sm="8" md="8" lg="9" xl="9">
                                <a
                                    v-if="company.search.data.allow && $moment(company.search.data.from_date + ' ' + company.search.data.from_time).isBefore($moment())"
                                    @click="updateCompanyAccessPopup(company.search.data)"
                                    class="success--text"
                                >
                                    Активная до {{ $moment(company.search.data.till_date).format('DD.MM.YYYY') }} {{ company.search.data.till_time }}
                                </a>
                                <a
                                    v-if="company.search.data.allow && !$moment(company.search.data.from_date + ' ' + company.search.data.from_time).isBefore($moment())"
                                    @click="updateCompanyAccessPopup(company.search.data)"
                                    class="warning--text"
                                >
                                    Активная до {{ $moment(company.search.data.till_date).format('DD.MM.YYYY') }} {{ company.search.data.till_time }}
                                </a>
                                <a
                                    v-if="!company.search.data.allow"
                                    @click="updateCompanyAccessPopup(company.search.data)"
                                    class="error--text"
                                >
                                    Заблокирована
                                </a>
                            </v-col>
                        </v-row>
                        <v-row wrap text-left subheading>
                            <v-col xs="6" sm="4" md="4" lg="3" xl="3">
                                Осталось просмотров:
                            </v-col>
                            <v-col xs="6" sm="8" md="8" lg="3" xl="3">
                                {{ company.search.data.resume_basic_limit }}
                            </v-col>
                            <v-col xs="6" sm="4" md="4" lg="3" xl="3" v-if="company.search.data.resume_extra_limit">
                                Докуплено просмотров:
                            </v-col>
                            <v-col xs="6" sm="8" md="8" lg="3" xl="3" v-if="company.search.data.resume_extra_limit">
                                {{ company.search.data.resume_extra_limit }}
                            </v-col>
                        </v-row>
                        <v-row wrap text-left subheading>
                            <v-col xs="6" sm="4" md="4" lg="3" xl="3">
                                Осталось контактов:
                            </v-col>
                            <v-col xs="6" sm="8" md="8" lg="3" xl="3">
                                {{ company.search.data.contact_basic_limit }}
                            </v-col>
                            <v-col xs="6" sm="4" md="4" lg="3" xl="3" v-if="company.search.data.contact_extra_limit">
                                Докуплено контактов:
                            </v-col>
                            <v-col xs="6" sm="8" md="8" lg="3" xl="3" v-if="company.search.data.contact_extra_limit">
                                {{ company.search.data.contact_extra_limit }}
                            </v-col>
                        </v-row>
                        <v-row
                            v-if="!company.search.loading"
                            wrap text-left subheading
                        >
                            <v-col xs="6" sm="4" md="4" lg="3" xl="3">
                                Администратор:
                            </v-col>
                            <v-col xs="6" sm="8" md="8" lg="9" xl="9">
                                {{ company.search.data.manager ? company.search.data.manager.name : 'Не указан' }}
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer/>
                        <v-btn
                            @click="removeCompanyPopup(company.search.data)"
                            color="error"
                            text
                        >
                            Удалить компанию
                        </v-btn>
                        <v-spacer/>
                    </v-card-actions>
                </v-card>
            </v-col>
            <v-col xs="12" sm="12" md="12" lg="4" xl="4">
                <v-card>
                    <v-toolbar flat class="grey lighten-4">
                        <v-toolbar-title>Комментарий</v-toolbar-title>
                        <v-spacer/>
                        <v-btn
                            @click="updateCommentPopup(company.search.data)"
                            color="primary"
                        >
                            Редактировать
                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <div class="pre">{{ company.search.data.comment || 'Комментарий отсутствует' }}</div>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row text-center wrap>
            <v-col xs="12">
                <v-card>
                    <v-toolbar flat class="grey lighten-4">
                        <v-toolbar-title>Пользователи</v-toolbar-title>
                        <v-spacer/>
                        <v-btn
                            @click="createUserPopup"
                            color="success"
                        >
                            Добавить
                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <v-data-table
                            :headers="user.search.headers"
                            :items="user.search.data"
                            :loading="user.search.loading"
                        >
                            <template v-slot:item="{ item }">
                                <tr>
                                    <td class="text-left">{{ item.id }}</td>
                                    <td class="text-left">{{ item.name }}</td>
                                    <td class="text-left">{{ item.phone }}</td>
                                    <td class="text-left">{{ item.email }}</td>
                                    <td class="text-left">{{ item.password }}</td>
                                    <td class="text-left">
                                        <a @click.prevent="assignVirtualPopup(item)">
                                            <span v-if="item.virtual">{{ item.virtual.first_name }} {{ item.virtual.middle_name }} {{ item.virtual.last_name }}</span>
                                            <span v-else-if="item.virtual_id">Аккаунт недоступен</span>
                                            <span v-else>Назначить</span>
                                        </a>
                                    </td>
                                    <td class="text-left">
                                        <span v-if="item.status === 'active'" class="success--text">Активен</span>
                                        <span v-else class="error--text">Заблокирован</span>
                                    </td>
                                    <td class="text-left">
                                        <div class="d-inline-flex align-center">
                                            <v-icon
                                                small
                                                class="mr-2"
                                                @click="userLogPopup(item)"
                                            >
                                                mdi-book-account
                                            </v-icon>
                                            <router-link
                                                v-if="false"
                                                :to="{name: 'CompanyView', params: {id: item.id}}"
                                                class="mr-2"
                                            >
                                                <v-icon
                                                    small
                                                >
                                                    mdi-eye
                                                </v-icon>
                                            </router-link>
                                            <v-icon
                                                small
                                                class="mr-2"
                                                @click="updateUserPopup(item)"
                                            >
                                                mdi-pencil
                                            </v-icon>
                                            <v-icon
                                                v-if="item.status === 'active'"
                                                small
                                                class="mr-2"
                                                @click="updateUserStatus(item, 'inactive')"
                                            >
                                                mdi-pause
                                            </v-icon>
                                            <v-icon
                                                v-else-if="item.status === 'inactive'"
                                                small
                                                class="mr-2"
                                                @click="updateUserStatus(item, 'active')"
                                            >
                                                mdi-play
                                            </v-icon>
                                            <v-icon
                                                small
                                                @click="removeUserPopup(item)"
                                            >
                                                mdi-delete
                                            </v-icon>
                                        </div>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row text-center wrap>
            <v-col xs="12">
                <v-card>
                    <v-toolbar flat class="grey lighten-4">
                        <v-toolbar-title>Комментарии и задачи</v-toolbar-title>
                        <v-spacer/>
                        <v-btn
                            @click="createTaskPopup"
                            color="success"
                        >
                            Добавить
                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <v-data-table
                            :headers="task.search.headers"
                            :items="task.search.data"
                            :disable-sort="true"
                            :disable-pagination="true"
                            :loading="task.search.loading"
                            hide-default-footer
                        >
                            <template v-slot:item="{ item }">
                                <tr>
                                    <td class="text-left">{{ item.created }}</td>
                                    <td class="text-left">{{ item.manager ? item.manager.name : 'Не указан' }}</td>
                                    <td class="text-left">{{ item.message }}</td>
                                    <td class="text-left">{{ item.schedule }}</td>
                                    <td class="text-left">
                                        <div class="d-inline-flex align-center">
                                            <a
                                                v-if="item.can_complete"
                                                @click="taskComplete(item)"
                                                class="mr-2"
                                            >
                                                <v-icon
                                                    small
                                                >
                                                    mdi-flag
                                                </v-icon>
                                            </a>
                                        </div>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row text-center wrap>
            <v-col xs="12">
                <v-card>
                    <v-toolbar flat class="grey lighten-4">
                        <v-toolbar-title>Журнал</v-toolbar-title>
                        <v-spacer/>
                        <v-btn
                            @click="log.search.show = !log.search.show"
                            color="default"
                            icon
                        >
                            <v-icon v-if="log.search.show">mdi-chevron-down</v-icon>
                            <v-icon v-else>mdi-chevron-up</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text v-if="log.search.show">
                        <v-row class="ma-0 pa-0">
                            <v-col md="2" class="my-0 py-0">
                                <v-menu
                                    v-model="log.search.menu.from_date"
                                    ref="menuLogFromDate"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                            v-model="logFromDate"
                                            label="Начало периода"
                                            prepend-icon="mdi-calendar"
                                            readonly
                                            v-on="on"
                                            class="my-0 ml-0 pl-0"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="log.search.filter.from_date"
                                        @change="searchLogs(); log.search.menu.from_date = false"
                                        locale="ru"
                                        first-day-of-week="1"
                                        color="primary"
                                    ></v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col md="2" class="ml-5 my-0 py-0">
                                <v-menu
                                    v-model="log.search.menu.till_date"
                                    ref="menuLogTillDate"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                            v-model="logTillDate"
                                            label="Окончание периода"
                                            prepend-icon="mdi-calendar"
                                            readonly
                                            v-on="on"
                                            class="my-0 ml-0 pl-0"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="log.search.filter.till_date"
                                        @change="searchLogs(); log.search.menu.till_date = false"
                                        locale="ru"
                                        first-day-of-week="1"
                                        color="primary"
                                    ></v-date-picker>
                                </v-menu>
                            </v-col>
                        </v-row>
                        <v-col md="12">
                            <v-pagination
                                v-if="log.search.total > 20"
                                v-model="log.search.filter.page"
                                @input="searchLogs"
                                :length="Math.ceil(log.search.total / 20)"
                                class="ma-0"
                            ></v-pagination>
                        </v-col>
                        <v-data-table
                            :items="log.search.data"
                            :disable-sort="true"
                            :disable-pagination="true"
                            :loading="log.search.loading"
                            hide-default-footer
                        >
                            <template v-slot:item="{ item }">
                                <tr @click="log.search.expanded.includes(item.id) ? log.search.expanded.splice(log.search.expanded.indexOf(item.id), 1) : log.search.expanded.push(item.id)">
                                    <td class="text-left" width="35%">{{ item.created }}</td>
                                    <td class="text-left" width="35%">
                                        <span v-if="item.category === 'company.access.allow'">
                                            Открыт доступ
                                        </span>
                                        <span v-if="item.category === 'company.access.disallow'">
                                            Закрыт доступ
                                        </span>
                                        <span v-if="item.category === 'company.user.create'">
                                            Пользователь создан
                                        </span>
                                        <span v-if="item.category === 'company.user.remove'">
                                            Пользователь удален
                                        </span>
                                    </td>
                                    <td>
                                        {{ item.data.manager }}
                                    </td>
                                </tr>
                                <tr v-if="log.search.expanded.includes(item.id) && ['company.access.allow', 'company.access.disallow'].includes(item.category)">
                                    <td class="pt-3">
                                        <p class="font-weight-bold">
                                            Было:
                                        </p>
                                        <p
                                            :class="{'grey--text': item.data.old.access_open === item.data.new.access_open}"
                                        >
                                            <span v-if="item.data.old.access_open">
                                                Доступ: {{ item.data.old.access_from }} - {{ item.data.old.access_till }}
                                            </span>
                                            <span v-else>
                                                Доступ закрыт
                                            </span>
                                        </p>
                                        <p
                                            :class="{'grey--text': item.data.old.resume_basic_limit === item.data.new.resume_basic_limit}"
                                        >
                                            Лимит просмотров резюме: {{ item.data.old.resume_basic_limit }}
                                            <span v-if="item.data.old.resume_extra_limit">
                                                + {{ item.data.old.resume_extra_limit }}
                                            </span>
                                        </p>
                                        <p
                                            :class="{'grey--text': item.data.old.contact_basic_limit === item.data.new.contact_basic_limit}"
                                        >
                                            Лимит просмотров контактов: {{ item.data.old.contact_basic_limit }}
                                            <span v-if="item.data.old.contact_extra_limit">
                                                + {{ item.data.old.contact_extra_limit }}
                                            </span>
                                        </p>
                                        <p
                                            :class="{'grey--text': item.data.old.ignore_schedule === item.data.new.ignore_schedule}"
                                        >
                                            <span v-if="item.data.old.ignore_schedule">
                                                Разрешен доступ в нерабочее время
                                            </span>
                                            <span v-else>
                                                Запрещен доступ в нерабочее время
                                            </span>
                                        </p>
                                    </td>
                                    <td class="pt-3">
                                        <p class="font-weight-bold">
                                            Стало:
                                        </p>
                                        <p
                                            :class="{'grey--text': item.data.old.access_open === item.data.new.access_open}"
                                        >
                                            <span v-if="item.data.new.access_open">
                                                Доступ: {{ item.data.new.access_from }} - {{ item.data.new.access_till }}
                                            </span>
                                            <span v-else>
                                                Доступ закрыт
                                            </span>
                                        </p>
                                        <p
                                            :class="{'grey--text': item.data.old.resume_basic_limit === item.data.new.resume_basic_limit}"
                                        >
                                            Лимит просмотров резюме: {{ item.data.new.resume_basic_limit }}
                                            <span v-if="item.data.new.resume_extra_limit">
                                                + {{ item.data.new.resume_extra_limit }}
                                            </span>
                                        </p>
                                        <p
                                            :class="{'grey--text': item.data.old.contact_basic_limit === item.data.new.contact_basic_limit}"
                                        >
                                            Лимит просмотров контактов: {{ item.data.new.contact_basic_limit }}
                                            <span v-if="item.data.new.contact_extra_limit">
                                                + {{ item.data.new.contact_extra_limit }}
                                            </span>
                                        </p>
                                        <p
                                            :class="{'grey--text': item.data.old.ignore_schedule === item.data.new.ignore_schedule}"
                                        >
                                            <span v-if="item.data.new.ignore_schedule">
                                                Разрешен доступ в нерабочее время
                                            </span>
                                            <span v-else>
                                                Запрещен доступ в нерабочее время
                                            </span>
                                        </p>
                                    </td>
                                </tr>
                                <tr v-else-if="log.search.expanded.includes(item.id) && ['company.user.create', 'company.user.remove'].includes(item.category)">
                                    <td colspan="2" class="pt-3">
                                        <p>
                                            {{ item.data.user }}
                                        </p>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-dialog
            v-if="company.access.show"
            v-model="company.access.show"
            max-width="600"
        >
            <v-card>
                <v-card-title class="headline">Редактирование доступа</v-card-title>
                <v-form
                    @submit.prevent="updateCompanyAccess"
                    autocomplete="off"
                >
                    <v-card-text>
                        <v-container>
                            <v-checkbox
                                v-model="company.access.data.allow"
                                label="Разрешить доступ"
                            />
                            <v-row>
                                <v-col md="5" class="ma-0 pa-0">
                                    <v-menu
                                        v-model="company.access.menu.from_date"
                                        ref="menuAccessFromDate"
                                        :disabled="!company.access.data.allow"
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        transition="scale-transition"
                                        offset-y
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                v-model="accessFromDate"
                                                :error-messages="company.access.errors.from_date"
                                                :disabled="!company.access.data.allow"
                                                label="Дата начала"
                                                prepend-icon="mdi-calendar"
                                                readonly
                                                v-on="on"
                                                class="col-md-2 mt-0 mb-0 ml-5 pl-5"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker
                                            v-model="company.access.data.from_date"
                                            locale="ru"
                                            first-day-of-week="1"
                                            color="primary"
                                            @input="company.access.errors.from_date = []"
                                        ></v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-col md="5" class="ma-0 pa-0">
                                    <v-menu
                                        v-model="company.access.menu.from_time"
                                        ref="menuAccessFromTime"
                                        :disabled="!company.access.data.allow"
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        transition="scale-transition"
                                        offset-y
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                v-model="company.access.data.from_time"
                                                :error-messages="company.access.errors.from_time"
                                                :disabled="!company.access.data.allow"
                                                label="Время начала"
                                                prepend-icon="mdi-clock-outline"
                                                readonly
                                                v-on="on"
                                                class="col-md-2 mt-0 mb-0 ml-5 pl-5"
                                            ></v-text-field>
                                        </template>
                                        <v-time-picker
                                            v-model="company.access.data.from_time"
                                            format="24hr"
                                            locale="ru"
                                            color="primary"
                                            @click:minute="$refs.menuAccessFromTime.save(company.access.data.from_time), company.access.errors.from_time = []"
                                        ></v-time-picker>
                                    </v-menu>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col md="5" class="ma-0 pa-0">
                                    <v-menu
                                        v-model="company.access.menu.till_date"
                                        ref="menuAccessTillDate"
                                        :disabled="!company.access.data.allow"
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        transition="scale-transition"
                                        offset-y
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                v-model="accessTillDate"
                                                :error-messages="company.access.errors.till_date"
                                                :disabled="!company.access.data.allow"
                                                label="Дата окончания"
                                                prepend-icon="mdi-calendar"
                                                readonly
                                                v-on="on"
                                                class="col-md-2 mt-0 mb-0 ml-5 pl-5"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker
                                            v-model="company.access.data.till_date"
                                            locale="ru"
                                            first-day-of-week="1"
                                            color="primary"
                                            @input="company.access.errors.till_date = []"
                                        ></v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-col md="5" class="ma-0 pa-0">
                                    <v-menu
                                        v-model="company.access.menu.till_time"
                                        ref="menuAccessTillTime"
                                        :disabled="!company.access.data.allow"
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        transition="scale-transition"
                                        offset-y
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                v-model="company.access.data.till_time"
                                                :error-messages="company.access.errors.till_time"
                                                :disabled="!company.access.data.allow"
                                                label="Время окончания"
                                                prepend-icon="mdi-clock-outline"
                                                readonly
                                                v-on="on"
                                                class="col-md-2 mt-0 mb-0 ml-5 pl-5"
                                            ></v-text-field>
                                        </template>
                                        <v-time-picker
                                            v-model="company.access.data.till_time"
                                            format="24hr"
                                            locale="ru"
                                            color="primary"
                                            @click:minute="$refs.menuAccessTillTime.save(company.access.data.till_time), company.access.errors.till_time = []"
                                        ></v-time-picker>
                                    </v-menu>
                                </v-col>
                            </v-row>
                            <v-checkbox
                                v-model="company.access.data.ignore_schedule"
                                label="Разрешить доступ в нерабочее время"
                                class="ma-0"
                            />
                            <v-checkbox
                                v-model="company.access.data.hide_history"
                                label="Скрыть историю просмотров"
                                class="ma-0"
                            />
                            <v-row>
                                <v-col md="12">
                                    <v-text-field
                                        v-model="company.access.data.resume_basic_limit"
                                        :error-messages="company.update.errors.resume_basic_limit"
                                        name="resume_basic_limit"
                                        label="Основной лимит просмотров резюме"
                                        type="text">
                                    </v-text-field>
                                    <v-text-field
                                        v-model="company.access.data.contact_basic_limit"
                                        :error-messages="company.update.errors.contact_basic_limit"
                                        name="contact_basic_limit"
                                        label="Основной лимит просмотров контактов резюме"
                                        type="text">
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col md="12">
                                    <v-text-field
                                        v-model="company.access.data.resume_extra_limit"
                                        :error-messages="company.update.errors.resume_extra_limit"
                                        name="resume_extra_limit"
                                        label="Дополнительный лимит просмотров резюме"
                                        type="text">
                                    </v-text-field>
                                    <v-text-field
                                        v-model="company.access.data.contact_extra_limit"
                                        :error-messages="company.update.errors.contact_extra_limit"
                                        name="contact_extra_limit"
                                        label="Дополнительный лимит просмотров контактов резюме"
                                        type="text">
                                    </v-text-field>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn
                            @click="company.access.data.allow = false; updateCompanyAccess()"
                            :loading="company.access.progress"
                            color="error"
                        >
                            Заблокировать
                        </v-btn>
                        <v-spacer/>
                        <v-btn
                            @click="company.access.show = false"
                            :disabled="company.access.progress"
                            text
                            color="error"
                        >
                            Отменить
                        </v-btn>
                        <v-btn
                            :loading="company.access.progress"
                            type="submit"
                            color="primary"
                        >
                            Сохранить
                        </v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
        <v-dialog
            v-if="company.update.show"
            v-model="company.update.show"
            max-width="500"
        >
            <v-card>
                <v-card-title class="headline">Редактирование компании</v-card-title>
                <v-form
                    @submit.prevent="updateCompany"
                    autocomplete="off"
                >
                    <v-card-text>
                        <v-text-field
                            v-model="company.update.data.name"
                            :error-messages="company.update.errors.name"
                            name="name"
                            label="Название"
                            type="text">
                        </v-text-field>
                        <v-select
                            v-model="company.update.data.manager_id"
                            :error-messages="company.update.errors.manager_id"
                            :items="manager.search.data"
                            :cache-items="true"
                            item-text="name"
                            item-value="id"
                            label="Администратор"
                        >
                        </v-select>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer/>
                        <v-btn
                            @click="company.update.show = false"
                            :disabled="company.update.progress"
                            text
                            color="error"
                        >
                            Отменить
                        </v-btn>
                        <v-btn
                            :loading="company.update.progress"
                            type="submit"
                            color="primary"
                        >
                            Сохранить
                        </v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
        <v-dialog
            v-if="company.comment.show"
            v-model="company.comment.show"
            max-width="500"
        >
            <v-card>
                <v-card-title class="headline">Редактирование комментария</v-card-title>
                <v-form
                    @submit.prevent="updateComment"
                    autocomplete="off"
                >
                    <v-card-text>
                        <v-textarea
                            v-model="company.comment.data.comment"
                            :error-messages="company.comment.errors.comment"
                            name="comment"
                            label="Комментария">
                        </v-textarea>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer/>
                        <v-btn
                            @click="company.comment.show = false"
                            :disabled="company.comment.progress"
                            text
                            color="error"
                        >
                            Отменить
                        </v-btn>
                        <v-btn
                            :loading="company.comment.progress"
                            type="submit"
                            color="primary"
                        >
                            Сохранить
                        </v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
        <v-dialog
            v-if="company.remove.show"
            v-model="company.remove.show"
            max-width="600"
        >
            <v-card>
                <v-card-title class="headline">Удалить компанию {{ company.remove.data.name }}?</v-card-title>
                <v-card-text>
                </v-card-text>
                <v-card-actions>
                    <v-spacer/>
                    <v-btn
                        @click="company.remove.show = false"
                        :disabled="company.remove.progress"
                        color="red darken-1"
                        text
                    >
                        Отменить
                    </v-btn>
                    <v-btn
                        @click="removeCompany"
                        :loading="company.remove.progress"
                        color="green darken-1"
                        text
                    >
                        Удалить
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
            v-if="user.create.show"
            v-model="user.create.show"
            max-width="500"
        >
            <v-card>
                <v-card-title class="headline">Новый пользователь</v-card-title>
                <v-form
                    @submit.prevent="createUser"
                    autocomplete="off"
                >
                    <v-card-text>
                        <v-text-field
                            v-model="user.create.data.person"
                            :error-messages="user.create.errors.person"
                            name="person"
                            label="Ф.И.О."
                            type="text">
                        </v-text-field>
                        <v-text-field
                            v-model="user.create.data.phone"
                            :error-messages="user.create.errors.phone"
                            name="phone"
                            label="Телефон"
                            type="text">
                        </v-text-field>
                        <v-text-field
                            v-model="user.create.data.email"
                            :error-messages="user.create.errors.email"
                            name="email"
                            label="Почта"
                            type="text">
                        </v-text-field>
                        <v-text-field
                            v-model="user.create.data.password"
                            :error-messages="user.create.errors.password"
                            name="password"
                            label="Пароль"
                            type="text">
                        </v-text-field>
                        <v-checkbox
                            v-model="user.create.data.chief"
                            label="Менеджер компании"
                        />
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer/>
                        <v-btn
                            @click="user.create.show = false"
                            :disabled="user.create.progress"
                            text
                            color="error"
                        >
                            Отменить
                        </v-btn>
                        <v-btn
                            :loading="user.create.progress"
                            type="submit"
                            color="primary"
                        >
                            Сохранить
                        </v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
        <v-dialog
            v-if="user.log.show"
            v-model="user.log.show"
            max-width="600"
        >
            <v-card>
                <v-card-title class="headline">Журнал пользователя</v-card-title>
                <v-form
                    @submit.prevent="searchUserLog"
                    autocomplete="off"
                >
                    <v-card-text>
                        <v-row class="ma-0 pa-0">
                            <v-col md="6" class="ma-0 pa-0">
                                <v-menu
                                    v-model="user.log.menu.from_date"
                                    ref="menuUserLogFromDate"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                            v-model="userLogFromDate"
                                            label="Начало периода"
                                            prepend-icon="mdi-calendar"
                                            readonly
                                            v-on="on"
                                            class="my-0 ml-0 pl-0"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="user.log.data.from_date"
                                        @change="searchUserLog(); user.log.menu.from_date = false"
                                        locale="ru"
                                        first-day-of-week="1"
                                        color="primary"
                                    ></v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col md="6" class="ma-0 pa-0">
                                <v-menu
                                    v-model="user.log.menu.till_date"
                                    ref="menuUserLogTillDate"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                            v-model="userLogTillDate"
                                            label="Окончание периода"
                                            prepend-icon="mdi-calendar"
                                            readonly
                                            v-on="on"
                                            class="my-0 ml-0 pl-0"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="user.log.data.till_date"
                                        @change="searchUserLog(); user.log.menu.till_date = false"
                                        locale="ru"
                                        first-day-of-week="1"
                                        color="primary"
                                    ></v-date-picker>
                                </v-menu>
                            </v-col>
                        </v-row>
                        <v-data-table
                            :items="user.log.log"
                            :loading="user.log.loading"
                            disable-pagination
                            hide-default-footer
                        >
                            <template v-slot:item="{ item }">
                                <tr>
                                    <td class="text-left">{{ item.created }}</td>
                                    <td class="text-left">{{ item.comment }}</td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer/>
                        <v-btn
                            @click="user.log.show = false"
                            text
                            color="error"
                        >
                            Закрыть
                        </v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
        <v-dialog
            v-if="user.remove.show"
            v-model="user.remove.show"
            max-width="600"
        >
            <v-card>
                <v-card-title class="headline">Удалить пользователя {{ user.remove.data.name }}?</v-card-title>
                <v-card-text>
                </v-card-text>
                <v-card-actions>
                    <v-spacer/>
                    <v-btn
                        @click="user.remove.show = false"
                        :disabled="user.remove.progress"
                        color="red darken-1"
                        text
                    >
                        Отменить
                    </v-btn>
                    <v-btn
                        @click="removeUser"
                        :loading="user.remove.progress"
                        color="green darken-1"
                        text
                    >
                        Удалить
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
            v-if="user.update.show"
            v-model="user.update.show"
            max-width="500"
        >
            <v-card>
                <v-card-title class="headline">Редактирование пользователя</v-card-title>
                <v-form
                    @submit.prevent="updateUser"
                    autocomplete="off"
                >
                    <v-card-text>
                        <v-text-field
                            v-model="user.update.data.person"
                            :error-messages="user.update.errors.person"
                            name="person"
                            label="Ф.И.О."
                            type="text">
                        </v-text-field>
                        <v-text-field
                            v-model="user.update.data.phone"
                            :error-messages="user.update.errors.phone"
                            name="phone"
                            label="Телефон"
                            type="text">
                        </v-text-field>
                        <v-text-field
                            v-model="user.update.data.email"
                            :error-messages="user.update.errors.email"
                            name="email"
                            label="Почта"
                            type="text">
                        </v-text-field>
                        <v-text-field
                            v-model="user.update.data.password"
                            :error-messages="user.update.errors.password"
                            name="password"
                            label="Пароль"
                            type="text">
                        </v-text-field>
                        <v-checkbox
                            v-model="user.update.data.chief"
                            label="Менеджер компании"
                        />
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer/>
                        <v-btn
                            @click="user.update.show = false"
                            :disabled="user.update.progress"
                            text
                            color="error"
                        >
                            Отменить
                        </v-btn>
                        <v-btn
                            :loading="user.update.progress"
                            type="submit"
                            color="primary"
                        >
                            Сохранить
                        </v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
        <v-dialog
            v-if="task.create.show"
            v-model="task.create.show"
            max-width="600"
        >
            <v-card>
                <v-card-title class="headline">Новый комментарий / Новая задача</v-card-title>
                <v-form
                    @submit.prevent="createTask"
                    autocomplete="off"
                >
                    <v-card-text>
                        <v-container>
                            <v-textarea
                                v-model="task.create.data.message"
                                :error-messages="task.create.errors.message"
                                label="Комментарий"
                            ></v-textarea>
                            <v-row>
                                <v-col md="5" class="ma-0 pa-0">
                                    <v-menu
                                        v-model="task.create.menu.schedule_date"
                                        ref="menuScheduleDate"
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        transition="scale-transition"
                                        offset-y
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                :value="scheduleDate"
                                                @click:clear="task.create.data.schedule_date = null"
                                                :error-messages="task.create.errors.schedule_date"
                                                label="Дата начала"
                                                prepend-icon="mdi-calendar"
                                                readonly
                                                clearable
                                                v-on="on"
                                                class="col-md-2 mt-0 mb-0 ml-0 pl-0"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker
                                            v-model="task.create.data.schedule_date"
                                            @change="task.create.menu.schedule_date = false"
                                            locale="ru"
                                            first-day-of-week="1"
                                            color="primary"
                                            @input="task.create.errors.schedule_date = []"
                                        ></v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-col md="5" class="ma-0 pa-0">
                                    <v-menu
                                        v-model="task.create.menu.schedule_time"
                                        ref="menuScheduleTime"
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        transition="scale-transition"
                                        offset-y
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                :value="task.create.data.schedule_time"
                                                @click:clear="task.create.data.schedule_time = null"
                                                :error-messages="task.create.errors.schedule_time"
                                                label="Время начала"
                                                prepend-icon="mdi-clock-outline"
                                                readonly
                                                clearable
                                                v-on="on"
                                                class="col-md-2 mt-0 mb-0 ml-5 pl-5"
                                            ></v-text-field>
                                        </template>
                                        <v-time-picker
                                            v-model="task.create.data.schedule_time"
                                            format="24hr"
                                            locale="ru"
                                            color="primary"
                                            @click:minute="$refs.menuScheduleTime.save(task.create.data.schedule_time), task.create.errors.schedule_time = []"
                                        ></v-time-picker>
                                    </v-menu>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer/>
                        <v-btn
                            @click="task.create.show = false"
                            :disabled="task.create.progress"
                            text
                            color="error"
                        >
                            Отменить
                        </v-btn>
                        <v-btn
                            :loading="task.create.progress"
                            type="submit"
                            color="primary"
                        >
                            Сохранить
                        </v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
        <v-dialog
            v-if="user.virtual.show"
            v-model="user.virtual.show"
            max-width="500"
        >
            <v-card>
                <v-card-title class="headline">Назначение виртуала</v-card-title>
                <v-card-text>
                    <v-simple-table>
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th>Виртуал</th>
                                    <th>Действие</th>
                                </tr>
                            </thead>
                            <tbody class="text-center">
                                <tr
                                    v-for="(v) in virtual.search.data"
                                    :key="v.id"
                                >
                                    <td class="text-left">{{ v.first_name }} {{ v.middle_name }} {{ v.last_name }}</td>
                                    <td class="text-left">
                                        <a v-if="user.virtual.user.virtual_id === v.id" @click.prevent="assignVirtual(v, 'unassign')" class="red--text">Отключить</a>
                                        <span v-else-if="!v.access_token || !v.access_token.length" class="grey--text">Нет токена</span>
                                        <span v-else-if="v.company_id && v.company_id.length >= 3" class="grey--text">Используется</span>
                                        <a v-else @click.prevent="assignVirtual(v, 'assign')">Назначить</a>
                                    </td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </v-card-text>
                <v-card-actions>
                    <v-spacer/>
                    <v-btn
                        @click="user.virtual.show = false"
                        :disabled="user.virtual.progress"
                        text
                        color="error"
                    >
                        Закрыть
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
export default {
    name: "CompanyViewController",
    props: {
        id: Number,
    },
    data () {
        return {
            company: {
                access: {
                    data: {
                        id: '',
                        allow: false,
                        contact_basic_limit: 0,
                        contact_extra_limit: 0,
                        from_date: this.$moment().format('YYYY-MM-DD'),
                        from_time: this.$moment().format('HH:mm'),
                        hide_history: false,
                        ignore_schedule: false,
                        resume_basic_limit: 0,
                        resume_extra_limit: 0,
                        till_date: this.$moment().format('YYYY-MM-DD'),
                        till_time: this.$moment().format('HH:mm'),
                    },
                    errors: {
                        id: [],
                        contact_basic_limit: [],
                        contact_extra_limit: [],
                        from_date: [],
                        from_time: [],
                        resume_basic_limit: [],
                        resume_extra_limit: [],
                        till_date: [],
                        till_time: [],
                    },
                    menu: {
                        from: false,
                    },
                    progress: false,
                    show: false,
                },
                comment: {
                    data: {
                        id: '',
                        comment: '',
                    },
                    errors: {
                        id: '',
                        comment: '',
                    },
                    progress: false,
                    show: false,
                },
                remove: {
                    data: {
                        id: '',
                        name: '',
                    },
                    progress: false,
                    show: false,
                },
                search: {
                    data: {
                        name: '',
                    },
                    loading: true,
                },
                update: {
                    data: {
                        id: '',
                        manager_id: 0,
                        name: '',
                    },
                    errors: {
                        id: '',
                        email: '',
                        manager: '',
                        password: '',
                        person: '',
                        phone: '',
                    },
                    progress: false,
                    show: false,
                },
            },
            log: {
                search: {
                    data: [],
                    expanded: [],
                    filter: {
                        from_date: this.$moment().subtract(1, 'months').format('YYYY-MM-DD'),
                        page: 1,
                        till_date: this.$moment().format('YYYY-MM-DD'),
                    },
                    loading: true,
                    menu: {
                        from_date: false,
                        till_date: false,
                    },
                    show: false,
                    total: 0,
                },
            },
            manager: {
                search: {
                    data: [],
                    loading: true,
                },
            },
            task: {
                create: {
                    data: {
                        company_id: 0,
                        message: '',
                        schedule_date: null,
                        schedule_time: null,
                    },
                    errors: {
                        message: [],
                        schedule_date: [],
                        schedule_time: [],
                    },
                    menu: {
                        schedule_date: false,
                        schedule_time: false,
                    },
                    progress: false,
                    show: false,
                },
                search: {
                    data: [],
                    headers: [
                        {
                            text: 'Дата',
                            value: 'created',
                        },
                        {
                            text: 'Администратор',
                            value: 'manager.name',
                        },
                        {
                            text: 'Комментарий',
                            value: 'message',
                        },
                        {
                            text: 'Время выполнения',
                            value: 'schedule',
                        },
                        {
                            text: 'Действия',
                            value: 'id',
                        },
                    ],
                    loading: true,
                },
            },
            user: {
                create: {
                    data: {
                        email: '',
                        manager: '',
                        password: '',
                        person: '',
                        phone: '',
                        chief: false,
                    },
                    errors: {
                        email: [],
                        manager: [],
                        password: [],
                        person: [],
                        phone: [],
                        chief: [],
                    },
                    progress: false,
                    show: false,
                },
                log: {
                    data: {
                        id: '',
                        from_date: this.$moment().subtract(1, 'months').format('YYYY-MM-DD'),
                        name: '',
                        till_date: this.$moment().format('YYYY-MM-DD'),
                    },
                    log: [],
                    menu: {
                        from_date: false,
                        till_date: false,
                    },
                    progress: false,
                    show: false,
                },
                remove: {
                    data: {
                        id: '',
                        name: '',
                    },
                    progress: false,
                    show: false,
                },
                search: {
                    data: [],
                    headers: [
                        {
                            text: 'ID',
                            value: 'id',
                        },
                        {
                            text: 'ФИО',
                            value: 'name',
                        },
                        {
                            text: 'Телефон',
                            value: 'phone',
                        },
                        {
                            text: 'Почта',
                            value: 'email',
                        },
                        {
                            text: 'Пароль',
                            value: 'password',
                        },
                        {
                            text: 'Виртуал',
                            value: 'virtual.name',
                        },
                        {
                            text: 'Статус',
                            value: 'status',
                        },
                        {
                            text: 'Действия',
                            value: 'id',
                        },
                    ],
                    loading: true,
                },
                update: {
                    data: {
                        id: '',
                        chief: false,
                        email: '',
                        manager: '',
                        password: '',
                        person: '',
                        phone: '',
                    },
                    errors: {
                        id: [],
                        cheif: [],
                        email: [],
                        manager: [],
                        password: [],
                        person: [],
                        phone: [],
                    },
                    progress: false,
                    show: false,
                },
                virtual: {
                    progress: false,
                    user: {},
                    show: false,
                }
            },
            virtual: {
                search: {
                    data: [],
                    loading: true,
                },
            },
        }
    },
    computed: {
        accessFromDate () {
            return this.formatDate(this.company.access.data.from_date)
        },
        accessTillDate () {
            return this.formatDate(this.company.access.data.till_date)
        },
        logFromDate () {
            return this.formatDate(this.log.search.filter.from_date)
        },
        logTillDate () {
            return this.formatDate(this.log.search.filter.till_date)
        },
        scheduleDate () {
            return this.formatDate(this.task.create.data.schedule_date)
        },
        userLogFromDate () {
            return this.formatDate(this.user.log.data.from_date)
        },
        userLogTillDate () {
            return this.formatDate(this.user.log.data.till_date)
        },
    },
    created () {
        this.searchCompany()
        this.searchUsers()
        this.searchVirtuals()
        this.searchManagers()
        this.searchLogs()
        this.searchTasks()
    },
    methods: {
        assignVirtual (virtual, action) {
            this.user.virtual.progress = true

            this.$axios.post('/manager/virtual/assign', {user_id: this.user.virtual.user.id, virtual_id: virtual.id, action: action})
                .then((res) => {
                    if (res.data.success) {
                        this.user.virtual.show = false
                    }

                    this.user.virtual.progress = false

                    this.searchUsers()
                })
                .catch(() => {
                    this.user.virtual.progress = false
                })
        },

        assignVirtualPopup (user) {
            this.user.virtual.user = {...user}
            this.user.virtual.show = true
        },

        createTask () {
            this.task.create.progress = true

            this.$axios.post('/manager/company/task/create', this.task.create.data)
                .then((res) => {
                    if (res.data.success) {
                        this.task.create.show = false
                        this.task.create.data.message = ''
                        this.task.create.data.schedule_date = null
                        this.task.create.data.schedule_time = null

                        this.searchTasks()
                    } else {
                        this.task.create.errors.message = res.data.errors.message || []
                        this.task.create.errors.schedule_date = res.data.errors.schedule_date || []
                        this.task.create.errors.schedule_time = res.data.errors.schedule_time || []
                    }

                    this.task.create.progress = false
                })
                .catch(() => {
                    this.task.create.progress = false
                })
        },

        createTaskPopup () {
            this.task.create.data.company_id = this.company.search.data.id
            this.task.create.show = true
        },

        createUser: function () {
            this.user.create.progress = true

            this.user.create.errors.chief = []
            this.user.create.errors.email = []
            this.user.create.errors.password = []
            this.user.create.errors.person = []
            this.user.create.errors.phone = []

            this.$axios.post('/manager/user/create', {company_id: this.id, ...this.user.create.data})
                .then((res) => {
                    if (res.data.success) {
                        this.user.create.show = false
                        this.user.create.data.chief = ''
                        this.user.create.data.email = ''
                        this.user.create.data.password = ''
                        this.user.create.data.person = ''
                        this.user.create.data.phone = ''
                    } else {
                        this.user.create.errors.chief = res.data.errors.chief || []
                        this.user.create.errors.email = res.data.errors.email || []
                        this.user.create.errors.password = res.data.errors.password || []
                        this.user.create.errors.person = res.data.errors.person || []
                        this.user.create.errors.phone = res.data.errors.phone || []
                    }

                    this.user.create.progress = false

                    this.searchUsers()
                    this.searchLogs()
                })
                .catch(() => {
                    this.user.create.progress = false
                })
        },

        createUserPopup: function () {
            this.user.create.show = true
        },

        formatDate (date) {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${day}.${month}.${year}`
        },

        removeCompany () {
            this.company.remove.progress = true

            this.$axios.post('/manager/company/remove', this.company.remove.data)
                .then((res) => {
                    if (res.data.success) {
                        this.company.remove.show = false
                        this.company.remove.data.id = 0
                        this.company.remove.data.name = ''

                        this.$router.push('/company')
                    }

                    this.company.remove.progress = false
                })
                .catch(() => {
                    this.company.remove.progress = false
                })
        },

        removeCompanyPopup (company) {
            this.company.remove.data.id = company.id
            this.company.remove.data.name = company.name
            this.company.remove.show = true
        },

        removeUser () {
            this.user.remove.progress = true

            this.$axios.post('/manager/user/remove', this.user.remove.data)
                .then((res) => {
                    if (res.data.success) {
                        this.user.remove.show = false
                        this.user.remove.data.id = 0
                        this.user.remove.data.name = ''

                        this.searchUsers()
                        this.searchLogs()
                    }

                    this.user.remove.progress = false
                })
                .catch(() => {
                    this.user.remove.progress = false
                })
        },

        removeUserPopup (user) {
            this.user.remove.data.id = user.id
            this.user.remove.data.name = user.name
            this.user.remove.show = true
        },

        searchCompany () {
            this.company.search.loading = true

            this.$axios.post('/manager/company/search', {id: this.id})
                .then(res => {
                    if (res.data.success) {
                        this.company.search.data = res.data.data
                    }

                    this.company.search.loading = false
                })
                .catch(() => {
                    this.company.search.loading = false
                })
        },

        searchLogs () {
            this.log.search.loading = true

            this.$axios.post('/manager/company/search/logs', {id: this.id, ...this.log.search.filter})
                .then(res => {
                    if (res.data.success) {
                        this.log.search.total = res.data.data.meta.total
                        this.log.search.data = res.data.data.data
                    }

                    this.log.search.loading = false
                })
                .catch(() => {
                    this.log.search.loading = false
                })
        },

        searchManagers () {
            this.manager.search.loading = true

            this.$axios.post('/manager/user/search')
                .then(res => {
                    if (res.data.success) {
                        this.manager.search.data = res.data.data.filter(m => {return m.manager})
                    }

                    this.manager.search.loading = false
                })
                .catch(() => {
                    this.manager.search.loading = false
                })
        },

        searchTasks () {
            this.task.search.loading = true

            this.$axios.post('/manager/company/task/search', {company_id: this.id})
                .then(res => {
                    if (res.data.success) {
                        this.task.search.data = res.data.data
                    }

                    this.task.search.loading = false
                })
                .catch(() => {
                    this.task.search.loading = false
                })
        },

        searchUserLog () {
            this.user.log.search = true

            this.$axios.post('/manager/company/search/logs/user', this.user.log.data)
                .then(res => {
                    if (res.data.success) {
                        this.user.log.log = res.data.data
                    }

                    this.user.log.loading = false
                })
                .catch(() => {
                    this.user.log.loading = false
                })
        },

        searchUsers () {
            this.user.search.loading = true

            this.$axios.post('/manager/user/search', {company_id: this.id})
                .then(res => {
                    if (res.data.success) {
                        this.user.search.data = res.data.data
                    }

                    this.user.search.loading = false
                })
                .catch(() => {
                    this.user.search.loading = false
                })
        },

        searchVirtuals () {
            this.virtual.search.loading = true

            this.$axios.post('/manager/virtual/search')
                .then(res => {
                    if (res.data.success) {
                        this.virtual.search.data = res.data.data
                    }

                    this.virtual.search.loading = false
                })
                .catch(() => {
                    this.virtual.search.loading = false
                })
        },

        taskComplete (task) {
            this.$axios.post('/manager/company/task/complete', {id: task.id})
                .then(() => {
                    this.searchTasks()
                })
                .catch(() => {
                    this.searchTasks()
                })
        },

        updateComment () {
            this.company.comment.progress = true

            this.company.comment.errors.id = []
            this.company.comment.errors.comment = []

            this.$axios.post('/manager/company/comment', this.company.comment.data)
                .then((res) => {
                    if (res.data.success) {
                        this.company.comment.show = false
                        this.company.comment.data.id = 0
                        this.company.comment.data.comment = ''

                        this.searchCompany()
                    } else {
                        this.company.comment.errors.id = res.data.errors.id || []
                        this.company.comment.errors.comment = res.data.errors.comment || []
                    }

                    this.company.comment.progress = false
                })
                .catch(() => {
                    this.company.comment.progress = false
                })
        },

        updateCommentPopup (company) {
            this.company.comment.data.id = company.id
            this.company.comment.data.comment = company.comment
            this.company.comment.show = true
        },

        updateCompany () {
            this.company.update.progress = true

            this.company.update.errors.id = []
            this.company.update.errors.name = []
            this.company.update.errors.resume_basic_limit = []
            this.company.update.errors.contact_basic_limit = []

            this.$axios.post('/manager/company/update', this.company.update.data)
                .then((res) => {
                    if (res.data.success) {
                        this.company.update.show = false
                        this.company.update.data.id = 0
                        this.company.update.data.name = ''
                        this.company.update.data.resume_basic_limit = 0
                        this.company.update.data.contact_basic_limit = 0

                        this.searchCompany()
                    } else {
                        this.company.update.errors.id = res.data.errors.id || []
                        this.company.update.errors.name = res.data.errors.name || []
                        this.company.update.errors.resume_basic_limit = res.data.errors.resume_basic_limit || []
                        this.company.update.errors.contact_basic_limit = res.data.errors.contact_basic_limit || []
                    }

                    this.company.update.progress = false
                })
                .catch(() => {
                    this.company.update.progress = false
                })
        },

        updateCompanyAccess () {
            this.company.access.progress = true

            this.company.access.errors.id = []
            this.company.access.errors.contact_basic_limit = []
            this.company.access.errors.contact_extra_limit = []
            this.company.access.errors.from_date = []
            this.company.access.errors.from_time = []
            this.company.access.errors.resume_basic_limit = []
            this.company.access.errors.resume_extra_limit = []
            this.company.access.errors.till_date = []
            this.company.access.errors.till_time = []

            this.$axios.post('/manager/company/access', this.company.access.data)
                .then((res) => {
                    if (res.data.success) {
                        this.company.access.show = false

                        this.searchCompany()
                        this.searchLogs()
                    } else {
                        this.company.access.errors.id = res.data.errors.id || []
                        this.company.access.errors.contact_basic_limit = res.data.errors.contact_basic_limit || []
                        this.company.access.errors.contact_extra_limit = res.data.errors.contact_extra_limit || []
                        this.company.access.errors.from_date = res.data.errors.from_date || []
                        this.company.access.errors.from_time = res.data.errors.from_time || []
                        this.company.access.errors.resume_basic_limit = res.data.errors.resume_basic_limit || []
                        this.company.access.errors.resume_extra_limit = res.data.errors.resume_extra_limit || []
                        this.company.access.errors.till_date = res.data.errors.till_date || []
                        this.company.access.errors.till_time = res.data.errors.till_time || []
                    }

                    this.company.access.progress = false
                })
                .catch(() => {
                    this.company.access.progress = false
                })
        },

        updateCompanyAccessPopup (company) {
            this.company.access.data.id = company.id
            this.company.access.data.allow = company.allow
            this.company.access.data.contact_basic_limit = company.contact_basic_limit
            this.company.access.data.contact_extra_limit = company.contact_extra_limit
            this.company.access.data.from_date = company.from_date
            this.company.access.data.from_time = company.from_time
            this.company.access.data.hide_history = company.hide_history
            this.company.access.data.ignore_schedule = company.ignore_schedule
            this.company.access.data.resume_basic_limit = company.resume_basic_limit
            this.company.access.data.resume_extra_limit = company.resume_extra_limit
            this.company.access.data.till_date = company.till_date
            this.company.access.data.till_time = company.till_time
            this.company.access.show = true
        },

        updateCompanyPopup (company) {
            this.company.update.data.id = company.id
            this.company.update.data.name = company.name
            this.company.update.data.manager_id = company.manager_id
            this.company.update.show = true
        },

        updateUser: function () {
            this.user.update.progress = true

            this.user.update.errors.id = []
            this.user.update.errors.email = []
            this.user.update.errors.password = []
            this.user.update.errors.person = []
            this.user.update.errors.phone = []
            this.user.update.errors.chief = []

            this.$axios.post('/manager/user/update', {company_id: this.id, ...this.user.update.data})
                .then((res) => {
                    if (res.data.success) {
                        this.user.update.show = false
                        this.user.update.data.id = ''
                        this.user.update.data.chief = false
                        this.user.update.data.email = ''
                        this.user.update.data.password = ''
                        this.user.update.data.person = ''
                        this.user.update.data.phone = ''
                    } else {
                        this.user.update.errors.id = res.data.errors.email || []
                        this.user.update.errors.chief = res.data.errors.chief || []
                        this.user.update.errors.email = res.data.errors.email || []
                        this.user.update.errors.password = res.data.errors.password || []
                        this.user.update.errors.person = res.data.errors.person || []
                        this.user.update.errors.phone = res.data.errors.phone || []
                    }

                    this.user.update.progress = false

                    this.searchUsers()
                })
                .catch(() => {
                    this.user.update.progress = false
                })
        },

        updateUserPopup (user) {
            this.user.update.data.id = user.id
            this.user.update.data.chief = user.chief
            this.user.update.data.email = user.email
            this.user.update.data.password = user.password
            this.user.update.data.person = user.name
            this.user.update.data.phone = user.phone
            this.user.update.show = true
        },

        updateUserStatus (user, status) {
            this.$axios.post('/manager/user/status', {id: user.id, status: status})
                .then(() => {
                    this.searchUsers()
                })
                .catch(() => {
                    this.searchUsers()
                })
        },

        userLogPopup (user) {
            this.user.log.data.id = user.id
            this.user.log.data.name = user.name
            this.user.log.log = []
            this.user.log.show = true
            this.searchUserLog()
        },
    },
}
</script>

<style>
.pre {
    white-space: pre-line;
}
</style>
